<template>
  <div class="pagemain">
    <my_menu2 v-if="project_name" :page_name="project_name + ' - 项目介绍编辑页'" back_icon="md-arrow-back" back_type="back"> </my_menu2>

    <div style="height: 40px;">

    </div>
    <div class="alert1">
      <Alert type="warning">填写提示：请完善所有内容，如没有请输入 ‘/’ 或
        ‘-’，填写后点击空白地方可以进行更新数据
      </Alert>
    </div>

    <div class="pagemain2">
      <!-- <div class="page_title">
      <span>
        <span class="back_home" @click="bank_home">
          <Icon type="md-arrow-back" />返回首页 &nbsp;|
        </span>
        
      </span>
    </div> -->



      <div>
        <div class="card1">
          <div class="card_title">公司详情</div>

          <div class="input_div">
            <div class="input_title">客户公司名称：</div>

            <div class="input_value">
              <Input size="small" v-model="update_data.company_name" placeholder="请输入.."
                @on-blur="input_blur_change('company_name', update_data.company_name)" style="width: 100%" />

              <div class="input_tishi">填写提示：客户公司全称（如xx制造有限公司）</div>
            </div>
          </div>

          <div class="input_div">
            <div class="input_title">客户公司简介：</div>

            <div class="input_value">
              <Input type="textarea" :rows="2" size="small" v-model="update_data.company_profile"
                @on-blur="input_blur_change('company_profile', update_data.company_profile)" placeholder="请输入.."
                style="width: 100%" />

              <div class="input_tishi">
                填写提示：公司成立时间、企业规模（包括占地面积和在职员工人数）、产线规模、公司产品等（企业官网信息为准）
              </div>
            </div>
          </div>

          <div class="input_div">
            <div class="input_title">项目照片：</div>
            <div>
              <div class="img_div2">
                <div v-for="(item, i) in img_list" :key="i" class="imgdiv3">
                  <div class="close_img" @click="close_img(item)">
                    <Icon type="md-close" color="#fff" />
                  </div>
                  <div class="img_div" @click="view_img(item.url)">
                    <img :src="item.url" alt="" style="height: 100%; height: 100%" />
                  </div>
                </div>
                <div>
                  <Upload :action="img_upload + '&project_id=' + project_id" ref="upload_img" :on-success="img_success">
                    <Button icon="ios-cloud-upload-outline" size="small">上传图片</Button>
                  </Upload>
                </div>
              </div>
              <div class="input_tishi">
                照片上传提示：5张横版照片（大门口带logo、面试集合点、厂区环境、工作场景、宿舍、食堂）
              </div>
            </div>
          </div>
          <div class="input_div">
            <div class="input_title">项目视频：</div>
            <div>
              <div class="img_div2">
                <div v-for="(item, i) in video_list" :key="i" class="imgdiv3">
                  <div class="close_img" @click.stop="close_video(item)">
                    <Icon type="md-close" color="#fff" />
                  </div>
                  <div class="img_div" @click="view_video(item.url)">
                    <video :src="item.url" alt="" style="height: 100%; height: 100%" />
                  </div>
                </div>
                <div>
                  <Upload ref="upload_video" :action="mp4_upload + '&project_id=' + project_id"
                    :on-success="img_success">
                    <Button icon="ios-cloud-upload-outline" type="small">上传视频</Button>
                  </Upload>
                </div>
              </div>
              <div class="input_tishi">视频上传提示：招聘工种的相关视频</div>
            </div>
          </div>

          <div></div>
        </div>
      </div>

      <!--  -->

      <div class="card1">
        <div class="card_title">项目信息</div>

        <div class="input_div">
          <div class="input_title">工作环境：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.work_environment"
              @on-blur="input_blur_change('work_environment', update_data.work_environment)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：车间是否有空调，有无噪声、灰尘、刺鼻气味等
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">用工性质：</div>

          <div class="input_value">
            <Input size="small" v-model="update_data.work_type"
              @on-blur="input_blur_change('work_type', update_data.work_type)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">填写提示：全职、兼职、全职兼职均可 三选一</div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">用工特殊说明：</div>

          <div class="input_value">
            <Input type="textarea" :rows="2" size="small" v-model="update_data.work_special_instructions" @on-blur="
              input_blur_change(
                'work_special_instructions',

                update_data.work_special_instructions
              )
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示：是否可要在校生，有何条件？（是否可开实习证明）
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">招聘岗位：</div>

          <div class="input_value">
            <Input type="textarea" :rows="2" size="small" v-model="update_data.recruitment_position" @on-blur="
              input_blur_change('recruitment_position', update_data.recruitment_position)
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">填写提示：具体职位名称，如操作工/装配工/电焊工</div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工服说明：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.work_uniform"
              @on-blur="input_blur_change('work_uniform', update_data.work_uniform)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：穿普通工服/无尘服/静电服？工服费用××元？能否报销，何时报销，报销形式？（没有可填无）
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工种说明：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.work_type_desc"
              @on-blur="input_blur_change('work_type_desc', update_data.work_type_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：具体的工作内容，生产什么产品？站班/坐班/走动班？是否操作机器？<br />
              是否属于流水线？有无体力工作？需详细说明
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工时说明：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.man_hour_desc"
              @on-blur="input_blur_change('man_hour_desc', update_data.man_hour_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：工作时间：xx点-xx点；长白班/两班倒/三班倒，多久一倒班？<br />
              计薪工时：每天计薪××小时，企业每月保证在岗××工时；休息时间：早饭、午饭、晚饭休息××分钟？

              <br />
              每月休几天，法定节假日休假情况？
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">就餐：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.repast_desc"
              @on-blur="input_blur_change('repast_desc', update_data.repast_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：厂区是否有食堂，食堂每餐××钱？<br />
              ①包吃，包吃几餐，几荤几素；

              <br />
              ②提供餐补，餐补按天/月发放，每天/每月××元，入职充饭卡/随下月薪资发放。

              <br />
              ③不包餐，食堂就餐多少钱一餐
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">住宿：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.dormitory_desc"
              @on-blur="input_blur_change('dormitory_desc', update_data.dormitory_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：住宿厂区内/厂区外，住宿距离厂区××公里，有无班车？<br />
              ①住宿：住宿××人间，有无住宿押金？有无住宿费？（住宿配备：卫浴？WiFi？洗衣机？）

              <br />
              ②不住宿：有无外住补贴？补贴××元?
              厂区周边是否有可自行解决的住宿点（旅店，或租房）

              <br />
              ③是否提供夫妻房？
            </div>
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">薪资介绍</div>

        <div class="input_div">
          <div class="input_title">安心保承诺薪资：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.promised_salary"
              @on-blur="input_blur_change('promised_salary', update_data.promised_salary)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：正常出勤/计件情况下，工友可拿到手的最低工资（可写xxxx元/月或者小时工保证xx元/小时）
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">薪资属性/构成：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.salary_structure"
              @on-blur="input_blur_change('salary_structure', update_data.salary_structure)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：同工同酬/小时工/计件工资（个人/集体）/综合工时制/其他
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">薪酬：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.salary_desc"
              @on-blur="input_blur_change('salary_desc', update_data.salary_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：固定薪资部分××元（是否等同于到底最低薪资标准），小时工填写XXX元/小时即可，<br />
              计件工资则需详细说明件数薪资等加班费：超过××工时算加班费，具体核算方式（如超过176工时按底薪/176*1.5/2/3倍核算，平时、周末、法定节假日需详细说明加班费用）

              <br />
              夜班津贴：有无夜班津贴，正式工/小时工××元/天全勤奖：如有，按何种方式核算（达不到多少天没有）
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">其他和钱相关补贴：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.other_subsidies" placeholder="请输入.."
              @on-blur="input_blur_change('other_subsidies', update_data.other_subsidies)" style="width: 100%" />

            <div class="input_tishi">
              填写提示：如年终奖/交通补/租房补/通讯补/过节费/高温补贴、防暑降温费、劳务补贴、路费报销等详细说明
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">发薪日/发放说明：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.pay_day"
              @on-blur="input_blur_change('pay_day', update_data.pay_day)" placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示："厂区直接发薪还是劳务公司发薪？几号发薪，是否压工资等<br />
              日结、周结（注明是否压工资，完工或离职是否结算剩余）,月结（发放上月几号到几号的工资）"
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工资/生活费预支：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.prepay_wage"
              @on-blur="input_blur_change('prepay_wage', update_data.prepay_wage)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：是否可预支工资/生活费，在职多少天可预支多少钱，可具体说明
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">银行黑户：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.bank_black"
              @on-blur="input_blur_change('bank_black', update_data.bank_black)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：是否能接受银行黑户者？能否微信/支付宝转账、他人代收？
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">银行卡要求：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.bank_card"
              @on-blur="input_blur_change('bank_card', update_data.bank_card)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">填写提示：不限? 或者限制哪个银行？</div>
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">保险</div>

        <div class="input_div">
          <div class="input_title">合同说明：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.contract_desc"
              @on-blur="input_blur_change('contract_desc', update_data.contract_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：和××签署xx合同？是否有转正机会，转正后有无社保
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">用工关系：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.work_relation" placeholder="请输入.."
              @on-blur="input_blur_change('work_relation', update_data.work_relation)" style="width: 100%" />

            <div class="input_tishi">填写提示：劳动关系 、劳务关系 、承揽关系</div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">保险说明：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.insurance_desc"
              @on-blur="input_blur_change('insurance_desc', update_data.insurance_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：入职缴纳什么险种？（五险；五险一金；单工伤；商保），<br />
              各险种的参保日期，多久可转厂内员工，是否交社保？
            </div>
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">录用条件</div>

        <div class="input_div">
          <div class="input_title">性别/年龄要求：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.age_gender_desc"
              @on-blur="input_blur_change('age_gender_desc', update_data.age_gender_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">填写提示：性别/xx岁-xx岁</div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">民族/户籍要求：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.nation_hukou_desc" @on-blur="
              input_blur_change('nation_hukou_desc', update_data.nation_hukou_desc)
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示：什么民族不接受（四大民族需具体写明）什么户籍的人不接受（当地人是否接受）等
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">证件/学历/经验要求：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.experience_desc"
              @on-blur="input_blur_change('experience_desc', update_data.experience_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：是否持证上岗（叉车证、焊工证、健康证等）没有写无<br />
              什么学历不要，不满足什么能力不要（如简单算数）

              <br />
              是否面试必须要有相关经验，无经验会影响面通率？（如有，请具体说明要什么经验）
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">体检说明：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.health_examination" @on-blur="
              input_blur_change('health_examination', update_data.health_examination)
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示：是否需要体检？是否有指定医院？如无指定医院，有哪些体检项目？<br />
              体检费用多少？能否报销？

              <br />
              候选人有近××月体检报告可直接使用？
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">其他硬性要求：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.other_requirements" @on-blur="
              input_blur_change('other_requirements', update_data.other_requirements)
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示：纹身伤疤；色盲色弱；犯罪前科；体内金属；离职再进厂需满足什么条件
            </div>
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">面试及入职流程</div>

        <div class="input_div">
          <div class="input_title">工作/面试地点：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.interview_location" @on-blur="
              input_blur_change('interview_location', update_data.interview_location)
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示：xx省xx市xx区/县，具体到门牌号,面试地点是否为工厂所在地？是否有驻场带面试？
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">面试携带/着装要求：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.interview_requirements" @on-blur="
              input_blur_change(
                'interview_requirements',

                update_data.interview_requirements
              )
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示：是否必须携带身份证原件？复印件/照片/电子身份证是否可用？<br />
              默认不能穿拖鞋、高跟鞋、裙子、短裤、背心，发型颜色正常，女生不美甲等
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">面试时间：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.interview_time"
              @on-blur="input_blur_change('interview_time', update_data.interview_time)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">填写提示：周几到周几，几点到几点，可面试？</div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">面试/入职流程：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="3" v-model="update_data.interview_flow"
              @on-blur="input_blur_change('interview_flow', update_data.interview_flow)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：是否有试工环节？从面试-入职周期几天？<br />
              试工多久，有无薪资，是否从试工当天算返费？

              <br />
              面试通过后，可否当天办理入职手续签合同？

              <br />
              是否当天可以入住宿舍？入职当天几点到厂区报道？找谁报道？
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">入职材料/通知模板：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="3" v-model="update_data.induction_materials" @on-blur="
              input_blur_change('induction_materials', update_data.induction_materials)
              " placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              填写提示：入职需携带手续（例身份证、身份证复印件、体检报告等详细说明）
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">入职费用：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="2" v-model="update_data.entry_fee"
              @on-blur="input_blur_change('entry_fee', update_data.entry_fee)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：厂牌押金、钥匙押金、宿舍押金；押金类费用离职是否可申请退还
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">离职说明：</div>

          <div class="input_value">
            <Input size="small" v-model="update_data.dimission_desc"
              @on-blur="input_blur_change('dimission_desc', update_data.dimission_desc)" placeholder="请输入.."
              style="width: 100%" />

            <div class="input_tishi">
              填写提示：离职需提前多久申请，至少上岗几日离职可结算薪资
            </div>
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">职位JD：</div>

          <div class="input_value">
            <Input size="small" type="textarea" :rows="4" v-model="update_data.jd"
              @on-blur="input_blur_change('jd', update_data.jd)" placeholder="请输入.." style="width: 100%" />

            <div class="input_tishi">
              JD模板：<br />【岗位名称】xx企业招xx！<br />
              【工作内容】（长白班！坐班！8小时工作制！）优势放前，干啥的放后

              <br />
              【薪资构成】薪资构成：底薪+绩效+补贴...只写构成不写具体金额

              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;发薪日：几号发薪，可否预支

              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;综合薪资区间：xxxx-xxxx元/月，员工平均工资xxxx元/月

              <br />
              【福利待遇】

              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;住宿：几人间，有无WIFI，是否独卫，是否有洗衣机等，重点写优势

              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;吃饭：免费吃还是有餐补，写优势

              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;其他：其他能吸引员工的福利政策，例如有夫妻房、有晋升、有购车福利等等

              <br />
              【招聘要求】18-40周岁，男女不限（需接受站班、加班、穿无尘服或者其他硬性要求）

              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";

import { http, open_new_page } from "@/utils/http.js";

export default {
  components: {
    my_menu2
  },
  data() {
    return {
      img_upload:
        process.env.VUE_APP_HOST +
        "/my_project/upload_introduction_img?token=" +
        this.$cookies.get("dx_token"),

      mp4_upload:
        process.env.VUE_APP_HOST +
        "/my_project/upload_introduction_video?token=" +
        this.$cookies.get("dx_token"),

      project_name: "",
      project_id: "",

      img_list: [],
      video_list: [],

      update_data: {
        company_name: "",
        company_profile: "",
        work_environment: "",
        work_type: "",
        work_special_instructions: "",
        recruitment_position: "",
        work_uniform: "",
        work_type_desc: "",
        man_hour_desc: "",
        repast_desc: "",
        dormitory_desc: "",
        promised_salary: "",
        salary_structure: "",
        salary_desc: "",
        other_subsidies: "",
        pay_day: "",
        prepay_wage: "",
        bank_black: "",
        bank_card: "",
        contract_desc: "",
        work_relation: "",
        insurance_desc: "",
        age_gender_desc: "",
        nation_hukou_desc: "",
        experience_desc: "",
        health_examination: "",
        other_requirements: "",
        interview_location: "",
        interview_requirements: "",
        interview_time: "",
        interview_flow: "",
        induction_materials: "",
        entry_fee: "",
        dimission_desc: "",
        jd: "",
      },
    };
  },
  mounted() {
    var query = this.$route.query;
    console.log(query);
    if (query.project_id) {
      this.project_id = query.project_id;
    }
    this.get_projectd_introduction_data();
  },

  methods: {
    img_success(e) {
      console.log(e);
      if (e.code == 0) {
        this.$refs.upload_img.clearFiles();
        this.$refs.upload_video.clearFiles();
        this.get_projectd_introduction_data();
      } else {
        this.$refs.upload_img.clearFiles();
        this.$refs.upload_video.clearFiles();
        this.$Message.error(e.msg);
      }
    },

    bank_home() {
      open_new_page("/");
    },

    input_blur_change(key, value) {
      console.log(key, value);
      this.update_value(key, value);
    },

    //更新数据
    update_value(key, value) {
      var that = this;
      var obj = {
        project_id: this.project_id,
        key: key,
        value: value,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_introduction_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取数据
    get_projectd_introduction_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_introduction_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.update_data = res.data.detail_info;
            that.project_name = res.data.project_name;
            that.img_list = res.data.image_list;
            that.video_list = res.data.video_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //删除媒体
    del_file(id, type) {
      var that = this;
      var obj = {
        file_id: id,
        file_type: type,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/del_introduction_imgage",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_projectd_introduction_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    view_img(url) {
      console.log(11111);
      this.$ImagePreview.show({
        previewList: [url],
      });
    },

    view_video(url) {
      console.log(11111);
      open_new_page(url);
    },

    close_img(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否要删除这个图片？</p>",
        onOk: () => {
          that.del_file(item.id, "img");
        },
        onCancel: () => { },
      });
    },

    close_video(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否要删除这个视频？</p>",
        onOk: () => {
          that.del_file(item.id, "video");
        },
        onCancel: () => { },
      });
    },
  },
};
</script>

<style scoped>
.alert1 {
  position: relative;
  top: 5px;
}

.pagemain2 {
  height: calc(100vh - 90px);
  overflow: auto;
}

.img_div2 {
  display: flex;
  align-items: center;
}

.close_img {
  z-index: 99;
  position: absolute;
  width: 15px;
  height: 15px;
  background: rgb(251, 144, 144);
  right: 10px;
  top: 0px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.close_img:hover {
  background: red;
}

.imgdiv3 {
  position: relative;
}

.card_title {
  background: #519a4f;
  color: #fff;
  text-align: center;
  width: 120px;
  position: absolute;
  border-radius: 0 0 10px 0;
  font-size: 13px;
  padding: 5px 0;
  top: 0;
  left: 0;
}

.img_div {
  height: 60px;
  width: 60px;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 5px;
  overflow: hidden;
}

.img_div:hover {
  cursor: pointer;
  border: 2px solid rgb(24, 155, 207) 109, 189);
  box-shadow: 0 0 3px #ccc;
}

.pagemain {
  background: #ececec;
  min-height: 100vh;
}

.input_value {
  width: 100%;
}

.card1 {
  background: #fff;
  margin: 10px;
  border-radius: 5px;
  overflow: hidden;
  padding: 35px 20px 10px 20px;
  position: relative;
}

.input_title {
  width: 170px;
  flex-shrink: 0;
  font-size: 14px;
  padding-top: 3px;
}

.input_tishi {
  font-size: 12px;
  color: #c9b6b6;
  padding: 3px 0 0 5px;
}

.input_div {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.back_home {
  color: #e2e9f1;
  cursor: pointer;
  margin-right: 10px;
}

.back_home:hover {
  color: #fff;
}

.page_title {
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 3px;
  padding: 0 15px 0 15px;
  background-color: #0466dd;
  color: #fff;
  height: 40px;
  line-height: 40px;
}
</style>
